import { translator } from "../i18n";
import ADate from "../../components/ADate";
import WISelect from "../../components/WISelect";
import {
  getPraticiensAnesthesie,
  getProfessionAnesthesie
} from "./scnr1-fetcher";
import {
  formatNbPeople,
  formatPraticiensAnesthesie,
  formatProfessionAnesthesie
} from "../formatter";
import { createLooperStep, createStep } from "../scenario-manager";
import List from "../../components/List";
import { getNbPeople } from "./scnr2-fetcher";

const buildStep1 = stepLabel => {
  const step = createStep({ label: stepLabel }, true);

  const dateOfSurgery = createStep({
    label: translator()._("W_QUELLE_EST_VOTRE_DATE_D_INTERVENTION"),
    component: {
      type: ADate,
      label: translator()._("W_QUELLE_EST_VOTRE_DATE_D_INTERVENTION")
    },
    returned: {
      key: "dateintervention"
    }
  });
  step.children.push(dateOfSurgery);

  const specialty = createStep({
    label: translator()._("W_QUEL_EST_LA_SPECIALITE_DE_VOTRE_INTERVENTION"),
    component: {
      type: WISelect,
      label: translator()._("W_QUEL_EST_LA_SPECIALITE_DE_VOTRE_INTERVENTION")
    },
    data: {
      fetchSource: getProfessionAnesthesie,
      formatSource: formatProfessionAnesthesie,
      keyValue: "idProfession"
    },
    returned: {
      key: "idProfession"
    }
  });
  step.children.push(specialty);

  const doctor = createStep({
    label: translator()._("W_STEP2_TITRE_MENU_QUEL_PRATICIEN"),
    component: {
      type: WISelect,
      label: translator()._("W_STEP2_TITRE_MENU_QUEL_PRATICIEN")
    },
    data: {
      fetchSource: getPraticiensAnesthesie,
      formatSource: formatPraticiensAnesthesie,
      keyValue: "idPraticien"
    },
    returned: {
      key: "idPraticien",
      dataKey: "idquestion"
    }
  });
  step.children.push(doctor);

  const nbPeople = createStep({
    code: "nbPeopleCode",
    label: translator()._("W_STEP2_TITRE_MENU_COMBIEN_DE_PERSONNE"),
    component: {
      type: List,
      label: translator()._("W_STEP2_MENU_LIST_NOMBRE_DE_PERSONNE")
    },
    data: {
      fetchSource: getNbPeople,
      formatSource: formatNbPeople,
      keyValue: "nbPeople"
    },
    returned: {
      key: "nbPeople"
    }
  });
  step.children.push(nbPeople);

  // keep it in last position
  const looperStep = createLooperStep(true);
  looperStep.byPass = true;
  step.children.push(looperStep);

  return step;
};

export const buildSteps = stepLabels => {
  return [buildStep1(stepLabels[0])];
};

export const getActiveStep = widgetType => {
  widgetType = widgetType.toLowerCase();

  const cases = {
    normal: { step: 1, subStep: 0 },
    question: { step: 0, subStep: 3 },
    anest: { step: 0, subStep: 0 }
  };

  return cases[widgetType] || { step: 0, subStep: 0 };
};
